class ProductCardVariantHover {
  constructor() {
    this.init();
  }

  init() {
    document.addEventListener('DOMContentLoaded', () => {
      this.setupVariantHoverListeners();
      this.observeNewCards();
    });
  }

  setupVariantHoverListeners(root = document) {
    const variantSwatches = root.querySelectorAll('[data-hover-image-src]:not([data-hover-initialized])');

    variantSwatches.forEach(swatch => {
      swatch.dataset.hoverInitialized = 'true';

      const productCard = swatch.closest('.card-wrapper');
      if (!productCard) return;

      const mainImage = productCard.querySelector('.card__media img');
      if (!mainImage) return;

      let originalSrc = null;
      let originalSrcset = null;
      let isImageLoaded = false;

      swatch.addEventListener('mouseenter', () => {
        const hoverImageSrc = swatch.getAttribute('data-hover-image-src');
        if (!hoverImageSrc || hoverImageSrc === 'null' || hoverImageSrc === '') return;

        if (!originalSrc) {
          originalSrc = mainImage.getAttribute('src');
          originalSrcset = mainImage.getAttribute('srcset');
        }

        if (!isImageLoaded) {
          const tempImg = new Image();
          tempImg.onload = () => {
            isImageLoaded = true;
            this.updateMainImage(mainImage, hoverImageSrc);
          };
          tempImg.src = hoverImageSrc;
        } else {
          this.updateMainImage(mainImage, hoverImageSrc);
        }
      });

      swatch.addEventListener('mouseleave', () => {
        if (originalSrc) {
          mainImage.setAttribute('src', originalSrc);
          if (originalSrcset) {
            mainImage.setAttribute('srcset', originalSrcset);
          }
        }
      });

      swatch.addEventListener('click', (e) => {
        const productUrl = swatch.getAttribute('data-product-url');
        if (productUrl && productUrl !== 'null' && productUrl !== '') {
          e.preventDefault();
          window.location.href = productUrl;
        }
      });
    });
  }

  observeNewCards() {
    const grid = document.getElementById('product-grid') || document.body;
    const observer = new MutationObserver((mutations) => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType !== 1) return;
          this.setupVariantHoverListeners(node);
        });
      });
    });
    observer.observe(grid, { childList: true, subtree: true });
  }

  updateMainImage(imgElement, newSrc) {
    imgElement.setAttribute('src', newSrc);
    imgElement.removeAttribute('srcset');
  }
}

new ProductCardVariantHover();

